import DashboardLayout from "components/layout/dashboard/DashboardLayout";
import Notification from "components/notifications/Notification";
import PageLoader from "components/pageLoader/PageLoader";
import AuthContext from "contexte/AuthContext";
import { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { fetchBotDetailedKpi, fetchBotsKpi } from "services/botServices";
import { formatNumberWithSpaces } from "utils/numbers";
import './bots.css'
import Tableau from "components/DataComponents/Tableau/Tableau";
import FilterComponent from "components/Filters/FilterComponent/FilterComponent";
import DateRangeSelector from "components/Filters/DateSelector/DateSelector";
import { BOT_RELEASE_DATE } from "utils/date";
import { bot_id_display_map } from "utils/display";


const Bots = () => {

  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  const [bots, setBots] = useState([]);
  const [details, setDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [selectedBotId, setSelectedBotId] = useState('');
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(0)

  const [selectedDate, setSelectedDate] = useState({
    date1: { startDate: new Date(BOT_RELEASE_DATE), endDate: new Date() },
    date2: { startDate: null, endDate: null },
  });

  const fetchKpi = async () => {
    try {
      setIsLoading(true)
      const data = await fetchBotsKpi(user, selectedDate.date1.startDate, selectedDate.date1.endDate)
      setBots(data)
      setSelectedBotId(data?.[0]?.bot_id)
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchDetails = async () => {
    try {
      setIsLoading
      if (selectedBotId) {
        (true)
        const data = await fetchBotDetailedKpi(user, selectedBotId, selectedDate.date1.startDate, selectedDate.date1.endDate, page, limit)
        setDetails(data)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchKpi()
  }, [selectedDate.date1.startDate, selectedDate.date1.endDate])

  useEffect(() => {
    fetchDetails()
  }, [selectedBotId, page, limit, selectedDate.date1.startDate, selectedDate.date1.endDate])

  const transformeDataToTbody = (data) => {
    console.log(data)
    return data?.map((item, index) => {
      const name = `${item.firstName} ${item.lastName}`
      return {
        data: [
          name,
          formatNumberWithSpaces(item.nb_trades),
          formatNumberWithSpaces(item.volume),
          formatNumberWithSpaces(item.fees),
          formatNumberWithSpaces(item.realized_pl),
          item.realized_plpc
        ],
        utils: { id: `${selectedBotId}/user/${item.user_uuid}/transactions?user_name=${name}` }
      }
    })
  }

  return (
    <DashboardLayout page={`${t("pages_name.bots")}`}>
      <div className='bots_title_component'>
        <h2>{t("pages.bots.title")}</h2>
      </div>
      <div className="bots_date_contaier">
        <DateRangeSelector selectedDate={selectedDate} setSelectedDate={setSelectedDate} withComparaison={false} />
      </div>
      <div className=''>
        <Notification />
        {
          !isLoading ? (
            <div className='bots_container'>

              <div className='bots_multi_box'>
                {bots.map((bot, index) =>
                  <div key={index} className='bots_multi_box_container'>
                    <p className='bots_container_title'>{bot_id_display_map[bot.bot_id] || bot.bot_id} :</p>
                    <div className='bots_row_space_between_box'>
                      <div className='bots_box'>
                        <p className='bots_p bots_item_desc'><span className='bots_item_title'>Volume :</span>{formatNumberWithSpaces(bot.volume)}</p>
                        <p className="bots_p bots_item_desc"><span className='bots_item_title'>Nombre de trades :</span> {formatNumberWithSpaces(bot.nb_trades)}</p>
                        <p className="bots_p bots_item_desc"><span className='bots_item_title'>Frais générés :</span>{formatNumberWithSpaces(bot.fees)}</p>
                      </div>
                      <div className='bots_box'>
                        <p className='bots_p bots_item_desc'><span className='bots_item_title'>Realized PL :</span>{formatNumberWithSpaces(bot.realized_pl)}</p>
                        <p className='bots_p bots_item_desc'><span className='bots_item_title'>Realized PLPC :</span>{formatNumberWithSpaces(bot.realized_plpc)}</p>
                      </div>
                    </div>
                  </div>
                )
                }
              </div>

              <div>
                <div className='transactions_switcher'>
                  {bots?.map(({ bot_id }, index) =>
                    (<div key={index} className={`transactions_tab ${selectedBotId === bot_id ? "transactions_tab_select" : "transactions_tab_not_select"}`} onClick={() => { setSelectedBotId(bot_id) }}>{bot_id_display_map[bot_id] || bot_id}</div>)
                  )}
                </div>
                <div className="bots_table_filter_container">
                  <FilterComponent
                    limit={true}
                    fetchLimit={limit}
                    setFetchLimit={setLimit}
                  />
                </div>
                <Tableau
                  tbody={transformeDataToTbody(details)}
                  thead={["User", 'Nombre de trades', "Volume", 'Frais', 'Realized PL', "Realized PLPC"]}
                  limit={limit}
                  hadLink={true}
                  linkPath={"/bots/"}
                  pagination={true}
                  setPage={setPage}
                  page={page}
                />
              </div>



            </div>
          ) : (
            <div className='pageLoaderBox'>
              <PageLoader />
            </div>
          )
        }
      </div>
    </DashboardLayout>
  )
}

export default Bots